<template>
  <div class="programmIng-footer">
    <div class="fotter-box">
      <div class="left">
        <div class="title">PROGRAMMING CARSOCIEDAD ANONIMA CERARCA</div>
        <div class="text">Build stronger customer relationships with us </div>
      </div>
      <div class="right">
        <div class="itemBox">
          <div class="item">
            <img src="../assets/email.png" alt="">
            <span>info@subco.com</span>
          </div>
          <div class="item">
            <img src="../assets/tel.png" alt="">
            <span>info@subco.com</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/address.png" alt="">
          <span>AV. CORONEL SAMUEL ALCAZAR URB. LA FLORIDA NO. 908 LIMA, LIMA, 07 Peru</span>
        </div>
        <div class="bt">If you have any questions, please feel free to contact us</div>
        <div class="inputInfo">
          <input type="text" placeholder="Your email">
          <div class="btn" @click="submit">Send</div>
        </div>
        <!-- <div class="text">By subscribing you agree to with our</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
    submit() {
      alert('kejayaan!')
    },
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.programmIng-footer {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;

  .fotter-box {
    padding: 100px 360px 100px;
    display: flex;
    justify-content: space-between;

    .left {
      margin-right: 26px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
      width: 500px;
      height: 400px;
      text-align: center;
      background: #063248;
      border-radius: 40px 40px 40px 40px;
      box-sizing: border-box;

      .title {
        margin-bottom: 33px;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 42px;
      }

      .text {
        font-size: 24px;
        color: #FFFFFF;
        line-height: 36px;
      }
    }

    .right {
      padding: 40px;
      width: 674px;
      height: 400px;
      background: #063248;
      border-radius: 40px 40px 40px 40px;
      box-sizing: border-box;

      .itemBox {
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .item {
        display: flex;
        align-items: center;

        img {
          margin-right: 8px;
          width: 50px;
          height: 50px;
        }

        span {
          font-size: 24px;
          color: #FFFFFF;
        }
      }

      .bt {
        margin-top: 34px;
        margin-bottom: 16px;
        font-weight: 600;
        font-size: 24px;
        color: #FFFFFF;
      }

      .inputInfo {
        display: flex;
        align-items: center;

        input {
          width: 417px;
          height: 48px;
          padding: 12px;
          box-sizing: border-box;
          background: #FFFFFF;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid #FFFFFF;
        }

        .btn {
          margin-left: 16px;
          width: 119px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border: 1px solid #FFFFFF;
          font-size: 16px;
          color: #FFFFFF;
          cursor: pointer;
        }
      }

      .text {
        margin-top: 16px;
        font-size: 12px;
        color: #FFFFFF;
      }
    }
  }

}
</style>
